const conceptList = [
  {
    name: "Ahenk",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fahenk.jpg?alt=media&token=2ac471c1-37e5-477f-a95e-c66e1f608665",
    defaultItems: [
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "İkili Hasır Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Yuvarlak Ahşap Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Helen",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fhelen.jpg?alt=media&token=259df54b-4ed7-41f1-9d96-6ef65cad2e84",
    defaultItems: [
      { name: "Yuvarlak Beyaz Sütun", checked: true },
      { name: "Beyaz Şamdan", checked: true },
      { name: "Beyaz Pleksi Sandalye", checked: true },
      { name: "Yarı Şeffaf Epoksi Tepsi", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Helen2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fhelen2.jpg?alt=media&token=a952eb80-860d-416b-83df-fbe97e7bd014",
    defaultItems: [
      { name: "Yuvarlak Beyaz Sütun", checked: true },
      { name: "Beyaz Şamdan", checked: true },
      { name: "Beyaz Pleksi Sandalye", checked: true },
      { name: "Rose Kulplu Aynalı Tepsi", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Lavinya",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Flavinya.jpg?alt=media&token=5fa281e4-627d-4902-9b5f-16a3b63c4be5",
    defaultItems: [
      { name: "Yuvarlak Ahşap Sütun", checked: true },
      { name: "Gold Örgülü Tepsi", checked: true },
      { name: "Ahşap Kafes Mumluk", checked: true },
      { name: "Ahşap Sade Sandalye", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Nazende Kahve",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fnazende%20kahve.jpg?alt=media&token=3bdfa86a-27b7-4998-83c1-6831253a182e",
    defaultItems: [
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Metal Kahverengi Kafes Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Ahşap Kare Çiçekli Orta Sehpa", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Nazende1",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fnazende1.jpg?alt=media&token=70962e04-fbe3-494a-ba73-279082e38bbd",
    defaultItems: [
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Ahşap Yuvarlak Çiçekli Orta Sehpa", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Nazende2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fnazende2.jpg?alt=media&token=6edc48c0-02cb-48e4-b5a3-5c4cb4567400",
    defaultItems: [
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Metal Kahverengi Kafes Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Ahşap Kare Çiçekli Orta Sehpa", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Nazende3",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fnazende3.jpg?alt=media&token=c423e8d3-5bcd-4360-9729-3dbec9683522",
    defaultItems: [
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Ahşap Yuvarlak Çiçekli Orta Sehpa", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "black",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fblack.jpg?alt=media&token=c4aa7203-8171-4c8b-b467-5855406e7c8c",
    defaultItems: [
      { name: "Beyaz Yuvarlak Sandalye", checked: true },
      { name: "Siyah Şamdan", checked: true },
      { name: "Kare Siyah Sütun", checked: true },
      { name: "Polyester Tepsi", checked: true },
      { name: "Better Together", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "kuğu",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fku%C4%9Fu.jpg?alt=media&token=90042b69-b2ed-40a6-9d3a-358edcc95753",
    defaultItems: [
      { name: "Şeffaf Pleksi Sandalye", checked: true },
      { name: "Şeffaf Pleksi Orta Sehpa", checked: true },
      { name: "Beyaz Silindir Mum", checked: true },
      { name: "Dikdörtgen Mermer Tepsi", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "okaliptus",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fokaliptus.jpg?alt=media&token=9d6aac92-63ca-4c03-9ad9-d3fca5620a8f",
    defaultItems: [
      { name: "Ahşap Yuvarlak Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Orta Sehpa", checked: true },
      { name: "Okaliptus Vazo", checked: true },
      { name: "Beyaz Silindir Mum", checked: true },
      { name: "Siyah Metal Kafes", checked: true },
      { name: "Yuvarlak Ahşap Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "okaliptus 3 renk",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2Fokaliptus%203%20renk.jpg?alt=media&token=293d8648-424d-4d74-9135-4d4dca6493ac",
    defaultItems: [
      { name: "Ahşap Yuvarlak Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Orta Sehpa", checked: true },
      { name: "Okaliptus Vazo", checked: true },
      { name: "Beyaz Silindir Mum", checked: true },
      { name: "Siyah Metal Kafes", checked: true },
      { name: "Yuvarlak Ahşap Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "çiçek",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2F%C3%A7i%C3%A7ek.jpg?alt=media&token=d748c40a-1787-4c1e-9ae8-00f8c72cf1a5",
    defaultItems: [
      { name: "Şeffaf Pleksi Sandalye", checked: true },
      { name: "Şeffaf Pleksi Orta Sehpa", checked: true },
      { name: "Şeffaf Cam Tepsi", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Sezen",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FSezen.jpg?alt=media&token=55719bed-b8e5-44ad-9832-51922a9e8bf7",
    defaultItems: [
      { name: "Ahşap Siyah Sandalye", checked: true },
      { name: "Kare Ahşap Sütun", checked: true },
      { name: "Rose Kulplu Aynalı Tepsi", checked: true },
      { name: "Rose Hediyelik Kutusu", checked: true }
    ]
  },
  {
    name: "Rose",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FRose.jpg?alt=media&token=25c9375d-b410-4fcd-85b7-c2d514da1f09",
    defaultItems: [
      { name: "Rose Bench", checked: true },
      { name: "Rose Oval Sütun", checked: true },
      { name: "Rose Yuvarlak Tepsi", checked: true },
      { name: "Rose Hediyelik Kutusu", checked: true },
      { name: "Rose Şamdan", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Zeytin",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FZeytin.jpg?alt=media&token=4c75a949-a816-47d6-9977-72c03bf02427",
    defaultItems: [
      { name: "Ahşap Otantik Sandalye", checked: true },
      { name: "Hasır Orta Sehpa", checked: true },
      { name: "Okaliptus Ahşap Çerçeve Tepsi", checked: true },
      { name: "Hasır Küp Vazo", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "İkili Hasır Mumluk", checked: true },
      { name: "Hasır Halı", checked: true },
    ]
  },
  {
    name: "Beste",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FBeste.jpg?alt=media&token=d1455532-c054-4e5b-8f02-15d85f45f42c",
    defaultItems: [
      { name: "Krem Puf Sandalye", checked: true },
      { name: "Ahşap Beyaz Orta Sehpa", checked: true },
      { name: "Yarı Şeffaf Epoksi Tepsi", checked: true },
      { name: "Beyaz Silindir Mum", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  }
  ,
  {
    name: "Mavi Çiçekli Nazende",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FMavi%20%C3%87i%C3%A7ekli%20Nazende.jpeg?alt=media&token=77346359-7a11-4161-a008-53a603de5432",
    defaultItems: [
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Çiçekli Orta Sehpa", checked: true },
      { name: "Metal Kahverengi Kafes Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Bahar",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FBahar.jpeg?alt=media&token=f8dd13ec-2aa7-4bd3-80cd-b4900ab3476d",
    defaultItems: [
      { name: "Ahşap Rattan Sandalye", checked: true },
      { name: "Ahşap Kare Çiçekli Orta Sehpa", checked: true },
      { name: "Metal Kahverengi Kafes Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Kasım1",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FKas%C4%B1m1.jpeg?alt=media&token=072cce6d-720b-4846-91cb-6553360214d3",
    defaultItems: [
      { name: "Ahşap Koyu Rattan Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Dikey Sehpa", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Gold Oval Tepsi", checked: true }
    ]
  },
  {
    name: "Kasım2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FKas%C4%B1m2.jpeg?alt=media&token=6a094235-4e16-4767-99ea-5654c73f27aa",
    defaultItems: [
      { name: "Ahşap Koyu Rattan Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Dikey Sehpa", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Kasım3",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FKas%C4%B1m3.jpeg?alt=media&token=897f4877-be27-4553-a498-ba426e6607ac",
    defaultItems: [
      { name: "Ahşap Koyu Rattan Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Dikey Sehpa", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "Hasır Oval Vazo", checked: true },
      { name: "Gold Oval Tepsi", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
  {
    name: "Papatya",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/eventConcepts%2FPapatya.jpeg?alt=media&token=852f8d59-d319-481b-9ce6-926339145c85",
    defaultItems: [
      { name: "Papatya Sandalye", checked: true },
      { name: "Ahşap Yuvarlak Dikey Sehpa", checked: true },
      { name: "Üçlü Dikey Ahşap Mumluk", checked: true },
      { name: "Ahşap Ağır Vazo", checked: true },
      { name: "Yuvarlak Ahşap Tepsi", checked: true },
      { name: "Hasır Halı", checked: true },
      { name: "Ray Spot", checked: true }
    ]
  },
];


export default conceptList;
